import { render, staticRenderFns } from "./accountSuspend.vue?vue&type=template&id=39d13f47&scoped=true"
import script from "./accountSuspend.vue?vue&type=script&lang=js"
export * from "./accountSuspend.vue?vue&type=script&lang=js"
import style0 from "./accountSuspend.vue?vue&type=style&index=0&id=39d13f47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d13f47",
  null
  
)

export default component.exports